import Keycloak from "keycloak-js";

export interface IProfile {
  name: string;
  email: string;
  givenName: string;
  familyName: string;
  organisation: string;
  phone: string;
  role: string;
}

const _kc = new Keycloak({
  clientId: "analytics-service",
  realm: "Analytics",
  url: `${process.env.REACT_APP_KC_AUTH_SERVER}`,
});

const initKeycloak = (onAuthenticatedCallback: () => void) => {
  const url = new URL(window.location.href);
  const pathname = url.pathname;

  const redirectUri =
    pathname === "/"
      ? `${process.env.REACT_APP_KC_REDIRECT_URI}`
      : window.location.href;
  console.log(redirectUri, pathname, url);
  _kc
    .init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      redirectUri,
    })
    .then((authenticated: boolean) => {
      onAuthenticatedCallback();
    })
    .catch(console.error);
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const getParsedToken = () => _kc.tokenParsed;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback: () => void) => {
  _kc.updateToken(5).then(successCallback).catch(doLogin);
};

const doRegister = _kc.register;

const doForgotPassword = () =>
  _kc.login({
    action: "UPDATE_PASSWORD",
  });

const getUsername = () =>
  _kc.tokenParsed ? _kc.tokenParsed.preferred_username : null;

const getProfile = (): IProfile | null =>
  _kc.tokenParsed
    ? {
        name: _kc.tokenParsed.name,
        email: _kc.tokenParsed.email,
        givenName: _kc.tokenParsed.given_name,
        familyName: _kc.tokenParsed.family_name,
        organisation: "Eigenmaps.ai",
        phone: "",
        role: "Admin",
      }
    : null;

const checkForScope = (scope: string) => {
  const scopes = _kc.tokenParsed?.scope.split(" ") as string[];
  return scopes.includes(scope);
};

const getUserTenantId = () => {
  return _kc.tokenParsed?.tenant_id;
};

const getUserAnalytics = () => {
  return _kc.tokenParsed?.analytics_id
    .split(", ")
    .map((id: string) => Number(id));
};

const getUserEmail = () => {
  return _kc.tokenParsed?.email;
};

const getUserRoles = () => {
  console.log("roles", _kc.tokenParsed?.resource_access?.roles);
  return _kc.tokenParsed?.resource_access?.roles;
};

const isEizenAdmin = () => {
  return _kc.tokenParsed?.realm_access?.roles.includes("Eizen");
};

const isAdministrator = () => {
  return _kc.tokenParsed?.realm_access?.roles.includes("Administrator");
};

const isUser = () => {
  return _kc.tokenParsed?.resource_access?.[
    "analytics-service"
  ]?.roles?.includes("User");
};

_kc.onTokenExpired = () => {
  _kc?.updateToken(5).catch(doLogin);
};

export const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  doForgotPassword,
  isLoggedIn,
  getToken,
  getParsedToken,
  updateToken,
  getUsername,
  doRegister,
  getProfile,
  checkForScope,
  getUserTenantId,
  getUserAnalytics,
  getUserEmail,
  getUserRoles,
  isEizenAdmin,
  isAdministrator,
  isUser,
};
